import { Controller } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import { ReactComponent as FilterIcon } from 'assets/icons/filter.svg';
import { ReactComponent as SearchIcon } from 'assets/icons/search.svg';
import StatusDropButton from 'components/StatusDropButton/StatusDropButton';
import TextField from 'components/TextField/TextField';
import { SEARCH, STATUS } from 'constants/formFields';
import { VC_STATUS_OPTIONS } from 'constants/general';

import type IValueChainMapFilters from '../../interfaces/IValueChainFilters';

import styles from './scss/ValueChainMapFilters.module.scss';

function ValueChainMapFilters({ control, onSearch }: IValueChainMapFilters) {
  const { t } = useTranslation();

  return (
    <div className={styles.root}>
      <div className={styles.input}>
        <Controller
          name={SEARCH}
          control={control}
          render={({ field: { name, value, onChange }, fieldState: { error } }) => (
            <TextField
              value={value}
              name={name}
              icon={<SearchIcon />}
              placeholder={t('valueChainMap.searchByName')}
              error={error?.message}
              onChange={({ target }) => onSearch({ search: target.value, onChange })}
            />
          )}
        />
      </div>
      <div className={styles.wrapper}>
        <div className={styles.label}>
          <FilterIcon />
          <p>
            {t('valueChainMap.filterByStatus')}
          </p>
        </div>
        <div className={styles.select}>
          <Controller
            control={control}
            name={STATUS}
            render={({ field: { value, onChange } }) => (
              <StatusDropButton
                options={VC_STATUS_OPTIONS}
                title={t('taskManagement.status')}
                labelKey="taskManagement.status"
                selectedOptions={value?.filter((item): item is string => item !== undefined)}
                onSelectionChange={onChange}
                className={styles.buttonStatus}
                classNameList={styles.buttonStatusList}
                clearAllSelected={() => onChange([])}
                translate
                hideSearch
              />
            )}
          />
        </div>
      </div>
    </div>
  );
}

export default ValueChainMapFilters;
